module.exports = __webpack_public_path__ + "static/img/cloud_assistant.58a679c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cloud_assistant.png
// module id = EVkr
// module chunks = 0